import { render } from "./Footer.vue?vue&type=template&id=115fe8e8&scoped=true"
import script from "./Footer.js?vue&type=script&lang=js"
export * from "./Footer.js?vue&type=script&lang=js"

import "./Footer.scss?vue&type=style&index=0&id=115fe8e8&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115fe8e8"]])

export default __exports__